import { SectionStatus } from "../../../../enums/SubSectionStatus";
import { jobStatus } from "../../CreateJobView/constants";

export const ApprovalStatus = {
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
};

export const ImageAltText = {
  pdfAltText: "PDF ICON",
};

export const defaultApprovalStates = [
  jobStatus.l2Approved,
  jobStatus.internalApprovalComplete,
  jobStatus.dispatchApproved,
];

export const PDFViewerConsts = {
  BACKGROUND_COLOR: "#6f7375",
  DOCUMENT_CLASSNAME: "documentStyling",
  PAGE_CLASSNAME: "pageStyling",
  LOADING_MESSAGE: "Loading PDF...",
};

export const sectionTemplate = [
  {
    key: "2",
    title: "Project Info Section",
    pdfs: [],
    status: ApprovalStatus.pending,
  },
  {
    key: "3",
    title: "Property Legal Description",
    pdfs: [],
    status: ApprovalStatus.pending,
  },
  {
    key: "4",
    title: "Property Owner Information",
    pdfs: [],
    status: ApprovalStatus.pending,
  },
  {
    key: "5",
    title: "General Contractor Information",
    pdfs: [],
    status: ApprovalStatus.pending,
  },
  {
    key: "6",
    title: "Subcontractor Information",
    pdfs: [],
    status: ApprovalStatus.pending,
  },
  {
    key: "7",
    title: "Bond Information",
    pdfs: [],
    status: ApprovalStatus.pending,
  },
];

export const sectionStatusMapTemplate = {
  "Project Info Section": {
    status: ApprovalStatus.pending,
    reasonForRejection: "",
  },
  "Property Legal Description": {
    status: ApprovalStatus.pending,
    reasonForRejection: "",
  },
  "Property Owner Information": {
    status: ApprovalStatus.pending,
    reasonForRejection: "",
  },
  "General Contractor Information": {
    status: ApprovalStatus.pending,
    reasonForRejection: "",
  },
  "Subcontractor Information": {
    status: ApprovalStatus.pending,
    reasonForRejection: "",
  },
  "Bond Information": {
    status: ApprovalStatus.pending,
    reasonForRejection: "",
  },
};

export const getSectionStatus = (jobStageStatus, sectionStatus, isSameUser) => {
  if (!jobStageStatus || !sectionStatus) {
    return ApprovalStatus.pending;
  }

  const isDefaultApproved = defaultApprovalStates?.includes(jobStageStatus);
  const isRejectedStage = [jobStatus.l1rejected, jobStatus.l2rejected].includes(
    jobStageStatus,
  );
  const isPendingStage = [
    jobStatus.l1ApprovalPending,
    jobStatus.l2approvalPending,
  ].includes(jobStageStatus);
  const isApprovedSection = [
    SectionStatus.L1_APPROVED,
    SectionStatus.L2_APPROVED,
  ].includes(sectionStatus);
  const isRejectedSection = [
    SectionStatus.L1_REJECTED,
    SectionStatus.L2_REJECTED,
  ].includes(sectionStatus);
  const isPendingSection = sectionStatus === SectionStatus.PENDING;

  const rules: [boolean, ApprovalStatus][] = [
    [isDefaultApproved, ApprovalStatus.approved],
    [isRejectedStage && isApprovedSection, ApprovalStatus.approved],
    [isRejectedStage && isRejectedSection, ApprovalStatus.rejected],
    [
      isPendingStage && isApprovedSection && !isSameUser,
      ApprovalStatus.pending,
    ],
    [isApprovedSection && isSameUser, ApprovalStatus.approved],
    [isRejectedSection, ApprovalStatus.rejected],
    [isPendingSection, ApprovalStatus.pending],
  ];

  const match = rules.find(([condition]) => condition);
  return match?.[1] ?? ApprovalStatus.pending;
};

export const SalesPersonViewConstants = {
  PROJECT_DETAILS_SECTION_KEY: "project details",
  NO_DOCUMENTS_TITLE: "No Uploaded Documents",
};